import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  createInventoryDoc,
  createRevaluationDoc,
  createGoodsReceive,
  createGoodsReturn,
  createGoodsTransfer,
  createMultipleReceive,
  createReturnReason,
  createSalesDocument,
  createWriteOffDoc,
  getAllParts,
  getDocumentsByType,
  getItemsDocs,
  getOrdersList,
  getPaymentDocs,
  getPaymentReturnBasis,
  getReceivesList,
  getReturnById,
  getReturnReasonsList,
  getRevaluationDoc,
  getSaleById,
  getUserCompaniesData,
  getWriteOffDoc,
  getInventoryDoc,
  getGoodsTransferDoc,
  getPartsByLocation,
  patchWriteOffDoc,
  patchInventoryDoc,
  patchRevaluationDoc,
  patchGoodsTransfer,
  patchGoodsReturn,
  patchSalesDocument,
  deleteWriteOffDoc,
  deleteReturn,
  deleteGoodsTransfer,
  deleteSalesDocument,
  deleteRevaluationDoc,
  deleteInventoryDoc,
  patchGoodsReceive,
  patchMultipleReceive,
  getSalesList,
} from "./operations.js";

const DocumentsSlice = createSlice({
  name: "documents",
  initialState: initialState.documents,
  reducers: {
    clearCashDocs: state => {
      state.paymentDocsLoading = false;
      state.error = null;
      state.paymentsDocs = {};
    },
    clearDetailedDoc: state => {
      state.detailedDocLoading = false;
      state.error = null;
      state.detailedDoc = {};
    },
    clearSale: state => {
      state.error = null;
      state.sale = {};
    },
    clearRevaluationData: state => {
      state.error = null;
      state.revaluationDoc = {};
    },
    clearWriteOffData: state => {
      state.writeoffLoading = false;
      state.error = null;
      state.writeOffDoc = {};
    },
    clearReceivedDoc: state => {
      state.receiveLoading = false;
      state.error = null;
      state.receiving = {};
    },
    clearInventoryData: state => {
      state.error = null;
      state.inventoryDoc = {};
    },
    clearGoodsTransferData: state => {
      state.error = null;
      state.goodsTransferDoc = {};
    },
    clearDocumentsByType: state => {
      state.documentsByTypeLoading = false;
      state.error = null;
      state.documentsByType = [];
    },
    clearReturnDoc: state => {
      state.returnDocLoading = false;
      state.error = null;
      state.returnDoc = {};
    },

    clearPartsToDisplay: state => {
      state.partsToDisplayLoading = false;
      state.error = null;
      state.partsToDisplay = [];
      state.allParts = [];
      state.partsByLocation = [];
    },

    setChosenLocationInWarehouse: (state, action) => {
      state.chosenLocationInWarehouse = action.payload;
    },
    setSecondChosenLocationInWarehouse: (state, action) => {
      state.secondChosenLocationInWarehouse = action.payload;
    },
    // для вибору локації для надходження
    setLocationForPart: (state, action) => {
      const { partId, locationId } = action.payload;
      state.locationsByPartId[partId] = locationId;
    },
    clearAllLocations: state => {
      state.locationsByPartId = {};
    },
    // кінець вибору локації для надходження
    clearChosenLocationInWarehouse: state => {
      state.chosenLocationInWarehouse = null;
    },
    clearSecondChosenLocationInWarehouse: state => {
      state.secondChosenLocationInWarehouse = null;
    },
    setChosenPeriod: (state, action) => {
      state.chosenPeriod = action.payload;
      console.log("State after setting period:", state.chosenPeriod);
    },
    clearChosenPeriod: state => {
      state.chosenPeriod = {};
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    clearSearchQuery: state => {
      state.searchQuery = "";
    },
    clearReturnInfo: state => {
      state.returnInfoLoading = false;
      state.returnInfo = {};
    },
    clearPaymentReturnInfo: state => {
      state.returnPaymentsInfoLoading = false;
      state.paymentsReturnInfo = {};
    },
  },
  extraReducers: builder =>
    builder
      // ! General operation to get all data of the user and all parts
      // Get user companies data
      .addCase(getUserCompaniesData.pending, (state, action) => {
        state.userCompaniesDataLoading = true;
        state.error = null;
      })
      .addCase(getUserCompaniesData.fulfilled, (state, action) => {
        state.userCompaniesDataLoading = false;
        state.userCompaniesData = action.payload;
      })
      .addCase(getUserCompaniesData.rejected, (state, action) => {
        state.userCompaniesDataLoading = false;
        state.error = null;
      })

      // Get all parts +
      .addCase(getAllParts.pending, (state, action) => {
        state.partsToDisplayLoading = true;
        state.error = null;
      })
      .addCase(getAllParts.fulfilled, (state, action) => {
        state.allParts = action.payload;
        state.partsToDisplayLoading = false;
      })
      .addCase(getAllParts.rejected, (state, action) => {
        state.partsToDisplayLoading = false;
        state.error = null;
      })

      // Get parts from particular location of the warehouse +
      .addCase(getPartsByLocation.pending, (state, action) => {
        state.partsToDisplayLoading = true;
        state.error = null;
      })
      .addCase(getPartsByLocation.fulfilled, (state, action) => {
        state.partsToDisplayLoading = false;
        state.partsByLocation = action.payload.parts;
      })
      .addCase(getPartsByLocation.rejected, (state, action) => {
        state.partsToDisplayLoading = false;
        state.error = null;
      })

      // Get documents of one type by date range +
      .addCase(getDocumentsByType.pending, state => {
        state.documentsByTypeLoading = true;
        state.error = null;
      })
      .addCase(getDocumentsByType.fulfilled, (state, action) => {
        state.documentsByTypeLoading = false;
        state.documentsByType = action.payload;
      })
      .addCase(getDocumentsByType.rejected, (state, action) => {
        state.documentsByTypeLoading = false;
        state.error = action.payload;
      })

      // Get all documents for Items and Services +
      .addCase(getItemsDocs.pending, (state, action) => {
        state.itemsDocsLoading = true;
        state.error = null;
      })
      .addCase(getItemsDocs.fulfilled, (state, action) => {
        state.itemsDocsLoading = false;
        state.itemsDocs = action.payload;
      })
      .addCase(getItemsDocs.rejected, (state, action) => {
        state.itemsDocsLoading = false;
        state.error = null;
      })

      // Get all payments documents +
      .addCase(getPaymentDocs.pending, (state, action) => {
        state.paymentDocsLoading = true;
        state.error = null;
      })
      .addCase(getPaymentDocs.fulfilled, (state, action) => {
        state.paymentDocsLoading = false;
        state.paymentsDocs = action.payload;
      })
      .addCase(getPaymentDocs.rejected, (state, action) => {
        state.paymentDocsLoading = false;
        state.error = null;
      })

      // Get list of orders for returns and receives +
      .addCase(getOrdersList.pending, (state, action) => {
        state.ordersListLoading = true;
        state.error = null;
      })
      .addCase(getOrdersList.fulfilled, (state, action) => {
        state.ordersListLoading = false;
        state.ordersList = action.payload;
      })
      .addCase(getOrdersList.rejected, (state, action) => {
        state.ordersListLoading = false;
        state.error = null;
      })

      // !REVALUATION

      // Get revaluation document by Id +
      .addCase(getRevaluationDoc.pending, (state, action) => {
        state.error = null;
      })
      .addCase(getRevaluationDoc.fulfilled, (state, action) => {
        state.revaluationDoc = action.payload;
      })
      .addCase(getRevaluationDoc.rejected, (state, action) => {
        state.error = null;
      })

      // Create revaluation doc +
      .addCase(createRevaluationDoc.pending, (state, action) => {
        state.error = null;
      })
      .addCase(createRevaluationDoc.rejected, (state, action) => {
        state.error = null;
      })

      // Patch revaluation doc +
      .addCase(patchRevaluationDoc.pending, (state, action) => {
        state.error = null;
      })
      .addCase(patchRevaluationDoc.rejected, (state, action) => {
        state.error = null;
      })

      // Delete revaluation doc +
      .addCase(deleteRevaluationDoc.pending, (state, action) => {
        state.error = null;
      })
      .addCase(deleteRevaluationDoc.fulfilled, (state, action) => {
        state.revaluationDoc = {};
      })
      .addCase(deleteRevaluationDoc.rejected, (state, action) => {
        state.error = null;
      })

      // ! INVENTORY
      // Get inventory document by Id +
      .addCase(getInventoryDoc.pending, (state, action) => {
        state.error = null;
      })
      .addCase(getInventoryDoc.fulfilled, (state, action) => {
        state.inventoryDoc = action.payload;
      })
      .addCase(getInventoryDoc.rejected, (state, action) => {
        state.error = null;
      })

      // Create inventory doc +
      .addCase(createInventoryDoc.pending, (state, action) => {
        state.error = null;
      })
      .addCase(createInventoryDoc.rejected, (state, action) => {
        state.error = null;
      })

      // Patch inventory document +
      .addCase(patchInventoryDoc.pending, (state, action) => {
        state.error = null;
      })
      .addCase(patchInventoryDoc.rejected, (state, action) => {
        state.error = null;
      })

      // Delete inventory document +
      .addCase(deleteInventoryDoc.pending, (state, action) => {
        state.error = null;
      })
      .addCase(deleteInventoryDoc.fulfilled, (state, action) => {
        state.inventoryDoc = {};
      })
      .addCase(deleteInventoryDoc.rejected, (state, action) => {
        state.error = null;
      })

      // ! Write-off
      // Get disposal document by Id +
      .addCase(getWriteOffDoc.pending, (state, action) => {
        state.writeoffLoading = true;
        state.error = null;
      })
      .addCase(getWriteOffDoc.fulfilled, (state, action) => {
        state.writeoffLoading = false;
        state.writeOffDoc = action.payload;
      })
      .addCase(getWriteOffDoc.rejected, (state, action) => {
        state.writeoffLoading = false;
        state.error = null;
      })

      // Create disposal document (write-off) +
      .addCase(createWriteOffDoc.pending, (state, action) => {
        state.writeoffLoading = true;
        state.error = null;
      })
      .addCase(createWriteOffDoc.fulfilled, (state, action) => {
        state.writeoffLoading = false;
      })
      .addCase(createWriteOffDoc.rejected, (state, action) => {
        state.writeoffLoading = false;
        state.error = null;
      })

      // Patch disposal document (write-off) +
      .addCase(patchWriteOffDoc.pending, (state, action) => {
        state.writeoffLoading = true;
        state.error = null;
      })
      .addCase(patchWriteOffDoc.fulfilled, (state, action) => {
        state.writeoffLoading = false;
      })
      .addCase(patchWriteOffDoc.rejected, (state, action) => {
        state.writeoffLoading = false;
        state.error = null;
      })

      // Delete write-off document +
      .addCase(deleteWriteOffDoc.pending, (state, action) => {
        state.writeoffLoading = true;
        state.error = null;
      })
      .addCase(deleteWriteOffDoc.fulfilled, (state, action) => {
        state.writeoffLoading = false;
        state.writeOffDoc = {};
      })
      .addCase(deleteWriteOffDoc.rejected, (state, action) => {
        state.writeoffLoading = false;
        state.error = null;
      })

      // ! TRANSFERS (CASH AND GOODS)
      // Get goods transfer document by Id +
      .addCase(getGoodsTransferDoc.pending, (state, action) => {
        state.error = null;
      })
      .addCase(getGoodsTransferDoc.fulfilled, (state, action) => {
        state.goodsTransferDoc = action.payload;
      })
      .addCase(getGoodsTransferDoc.rejected, (state, action) => {
        state.error = null;
      })

      // Create goods transfer between two legal entities +
      .addCase(createGoodsTransfer.pending, (state, action) => {
        state.error = null;
      })
      .addCase(createGoodsTransfer.rejected, (state, action) => {
        state.error = null;
      })

      // Patch goods transfer document +
      .addCase(patchGoodsTransfer.pending, (state, action) => {
        state.error = null;
      })
      .addCase(patchGoodsTransfer.rejected, (state, action) => {
        state.error = null;
      })

      // Delete goods transfer document +
      .addCase(deleteGoodsTransfer.pending, (state, action) => {
        state.writeoffLoading = true;
        state.error = null;
      })
      .addCase(deleteGoodsTransfer.fulfilled, (state, action) => {
        state.writeoffLoading = false;
        state.goodsTransferDoc = {};
      })
      .addCase(deleteGoodsTransfer.rejected, (state, action) => {
        state.writeoffLoading = false;
        state.error = null;
      })

      // ! RETURNS (CASH AND GOODS)

      // Get sale by Id +
      .addCase(getReturnById.pending, (state, action) => {
        state.returnDocLoading = true;
        state.error = null;
      })
      .addCase(getReturnById.fulfilled, (state, action) => {
        state.returnDocLoading = false;
        state.returnDoc = action.payload;
      })
      .addCase(getReturnById.rejected, (state, action) => {
        state.returnDocLoading = false;
        state.error = null;
      })

      // Get return reasons list for goods return +
      .addCase(getReturnReasonsList.pending, (state, action) => {
        state.returnDocLoading = true;
        state.error = null;
      })
      .addCase(getReturnReasonsList.fulfilled, (state, action) => {
        state.returnDocLoading = false;
        state.returnReasons = action.payload;
      })
      .addCase(getReturnReasonsList.rejected, (state, action) => {
        state.returnDocLoading = false;
        state.error = null;
      })

      // Create reason for return document (goods return) +
      .addCase(createReturnReason.pending, (state, action) => {
        state.error = null;
      })
      .addCase(createReturnReason.fulfilled, (state, action) => {
        state.returnReasons.push(action.payload);
      })
      .addCase(createReturnReason.rejected, (state, action) => {
        state.error = null;
      })

      // Create return document (goods return) +
      .addCase(createGoodsReturn.pending, (state, action) => {
        state.returnDocLoading = true;
        state.error = null;
      })
      .addCase(createGoodsReturn.fulfilled, (state, action) => {
        state.returnDocLoading = false;
      })
      .addCase(createGoodsReturn.rejected, (state, action) => {
        state.returnDocLoading = false;
        state.error = null;
      })

      // Patch return document (goods return) +
      .addCase(patchGoodsReturn.pending, (state, action) => {
        state.returnDocLoading = true;
        state.error = null;
      })
      .addCase(patchGoodsReturn.fulfilled, (state, action) => {
        state.returnDocLoading = false;
      })
      .addCase(patchGoodsReturn.rejected, (state, action) => {
        state.returnDocLoading = false;
        state.error = null;
      })

      // Get list of base documents and reasons for payments returns
      .addCase(getPaymentReturnBasis.pending, (state, action) => {
        state.returnPaymentsInfoLoading = true;
        state.error = null;
      })
      .addCase(getPaymentReturnBasis.fulfilled, (state, action) => {
        state.returnPaymentsInfoLoading = false;
        state.paymentsReturnBasis = action.payload;
      })
      .addCase(getPaymentReturnBasis.rejected, (state, action) => {
        state.returnPaymentsInfoLoading = false;
        state.error = null;
      })

      // Delete return +
      .addCase(deleteReturn.pending, (state, action) => {
        state.returnDocLoading = true;
        state.error = null;
      })
      .addCase(deleteReturn.fulfilled, (state, action) => {
        state.returnDocLoading = false;
        state.returnDoc = {};
      })
      .addCase(deleteReturn.rejected, (state, action) => {
        state.returnDocLoading = false;
        state.error = null;
      })

      // ! RECEIVES
      // Get receives list +
      .addCase(getReceivesList.pending, (state, action) => {
        state.receiveLoading = true;
        state.error = null;
      })
      .addCase(getReceivesList.fulfilled, (state, action) => {
        state.receiveLoading = false;
        state.receives = action.payload;
      })
      .addCase(getReceivesList.rejected, (state, action) => {
        state.receiveLoading = false;
        state.error = null;
      })

      // Create goods receive document (goods receive)
      .addCase(createGoodsReceive.pending, (state, action) => {
        state.receiveLoading = true;
        state.error = null;
      })
      .addCase(createGoodsReceive.fulfilled, (state, action) => {
        state.receiveLoading = false;
      })
      .addCase(createGoodsReceive.rejected, (state, action) => {
        state.receiveLoading = false;
        state.error = null;
      })

      // Patch goods receive document (goods receive) +
      .addCase(patchGoodsReceive.pending, (state, action) => {
        state.receiveLoading = true;
        state.error = null;
      })
      .addCase(patchGoodsReceive.fulfilled, (state, action) => {
        state.receiveLoading = false;
      })
      .addCase(patchGoodsReceive.rejected, (state, action) => {
        state.receiveLoading = false;
        state.error = null;
      })

      // Create goods receive from several orders
      .addCase(createMultipleReceive.pending, (state, action) => {
        state.receiveLoading = true;
        state.error = null;
      })
      .addCase(createMultipleReceive.fulfilled, (state, action) => {
        state.receiveLoading = false;
      })
      .addCase(createMultipleReceive.rejected, (state, action) => {
        state.receiveLoading = false;
        state.error = null;
      })

      // Patch goods receive from several orders +
      .addCase(patchMultipleReceive.pending, (state, action) => {
        state.receiveLoading = true;
        state.error = null;
      })
      .addCase(patchMultipleReceive.fulfilled, (state, action) => {
        state.receiveLoading = false;
      })
      .addCase(patchMultipleReceive.rejected, (state, action) => {
        state.receiveLoading = false;
        state.error = null;
      })

      // ! SALES
      // Get sales list +
      .addCase(getSalesList.pending, (state, action) => {
        state.saleListLoading = true;
        state.error = null;
      })
      .addCase(getSalesList.fulfilled, (state, action) => {
        state.salesList = action.payload;
        state.saleListLoading = false;
      })
      .addCase(getSalesList.rejected, (state, action) => {
        state.saleListLoading = false;
        state.error = null;
      })

      // Get sale by Id +
      .addCase(getSaleById.pending, (state, action) => {
        state.error = null;
      })
      .addCase(getSaleById.fulfilled, (state, action) => {
        state.sale = action.payload;
      })
      .addCase(getSaleById.rejected, (state, action) => {
        state.error = null;
      })

      // Create goods sale document (goods sale) +
      .addCase(createSalesDocument.pending, (state, action) => {
        state.error = null;
      })
      .addCase(createSalesDocument.rejected, (state, action) => {
        state.error = null;
      })

      // Patch sales document (sales) +
      .addCase(patchSalesDocument.pending, (state, action) => {
        state.error = null;
      })
      .addCase(patchSalesDocument.rejected, (state, action) => {
        state.error = null;
      })

      // Delete sales document (sales) +
      .addCase(deleteSalesDocument.pending, (state, action) => {
        state.error = null;
      })
      .addCase(deleteSalesDocument.fulfilled, (state, action) => {
        state.sale = {};
      })
      .addCase(deleteSalesDocument.rejected, (state, action) => {
        state.error = null;
      }),
});

export const {
  clearCashDocs,
  clearDetailedDoc,
  clearRevaluationData,
  clearInventoryData,
  clearWriteOffData,
  clearReceivedDoc,
  clearGoodsTransferData,
  clearDocumentsByType,
  clearReturnDoc,
  clearSale,
  setChosenLocationInWarehouse,
  setSecondChosenLocationInWarehouse,
  clearChosenLocationInWarehouse,
  clearSecondChosenLocationInWarehouse,
  clearPartsToDisplay,
  setChosenPeriod,
  clearChosenPeriod,
  setSearchQuery,
  clearSearchQuery,
  clearReturnInfo,
  clearPaymentReturnInfo,
  setLocationForPart,
  clearAllLocations,
} = DocumentsSlice.actions;
export default DocumentsSlice.reducer;
